import wordmarkLight from '../../assets/brand/voiceiq-wordmark-light.svg';
import wordmarkDark from '../../assets/brand/voiceiq-wordmark-dark.svg';
import markLight from '../../assets/brand/voiceiq-mark-light.svg';
import markDark from '../../assets/brand/voiceiq-mark-dark.svg';
import loadingLight from '../../assets/brand/voiceiq-loading-light.svg';
import loadingDark from '../../assets/brand/voiceiq-loading-dark.svg';

export type LogoVariant = 'wordmark' | 'mark' | 'loading';
export type LogoTheme = 'light' | 'dark';

interface LogoProps {
  variant?: LogoVariant;
  theme?: LogoTheme;
  href?: string | null;
  height?: number;
  className?: string;
  alt?: string;
}

const sources: Record<LogoVariant, Record<LogoTheme, string>> = {
  wordmark: { light: wordmarkLight, dark: wordmarkDark },
  mark: { light: markLight, dark: markDark },
  loading: { light: loadingLight, dark: loadingDark },
};

export function Logo({
  variant = 'wordmark',
  theme = 'light',
  href = 'https://voiceiq.logicv.com',
  height = 32,
  className,
  alt = 'VoiceIQ',
}: LogoProps) {
  const src = sources[variant]?.[theme] ?? sources.wordmark.light;

  const img = (
    <img
      src={src}
      alt={alt}
      style={{ height, width: 'auto', display: 'block' }}
      className={className}
    />
  );

  if (variant === 'loading' || !href) return img;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'inline-block', lineHeight: 0 }}
      aria-label={alt}
    >
      {img}
    </a>
  );
}

export default Logo;
